
import EVENT_DATA from '../data/EVENT_DATA'

import LAMPS from "../images/lamps.jpg"

import SnowBackground from '../components/SnowBackground';


import ImageGallery from "react-image-gallery";
// import stylesheet if you're not already using CSS @import
import "react-image-gallery/styles/css/image-gallery.css";

const images = [
  {
    original: LAMPS,
    thumbnail: LAMPS,
  },
  // {
  //   original: "https://picsum.photos/id/1015/1000/600/",
  //   thumbnail: "https://picsum.photos/id/1015/250/150/",
  // },
  // {
  //   original: "https://picsum.photos/id/1019/1000/600/",
  //   thumbnail: "https://picsum.photos/id/1019/250/150/",
  // },
];


const email_func = () => {

}



export default function Event() {


    return (
      
      <div style={{ maxWidth:'1200px', padding: '15px', color: 'white', width: '' }}>
        <h1 style={{ padding: '0 0 20px 0px' }}>
          {EVENT_DATA[28_02_2026].title}
        </h1>

        <p> A gallery exhibition event dedicated to the winter season. 
        </p>
        <br/>

        <p> 
            In 2026 we acknowledge urgency and the ways we come together. 
        </p>
        <p>
        We focus and reflect on our collective enjoyments of the longest season
        </p>
        <p>
        and we commemorate and celebrate our collective battles against it:
        </p>
        <p>
        the snow, the cold and the increasingly hostile world.
        </p>
        <br/>

        
        <ImageGallery showFullscreenButton={false} items={images} showNav={false} showPlayButton={false} />

        {/* <button onClick={email_func}>  */}


        <p> Open to the public night of feb 28th 2026. 
        </p>

        <p> 5$ or pay what you can -
        </p>
        <br/>
        <a style={{color:'orange'}} href="mailto:latenspace.media@gmail.com?subject=Nuit%20Blanche%20%40%20Cultural%20Center">
          <p>DM for more info</p>
        </a>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
      <SnowBackground/>
      </div>
    
    );
  }
  